<template>
    <router-view />
</template>

